import React, { useState } from "react";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { BellAlertIcon } from "@heroicons/react/24/solid";

const FlashNotice = ({
  message,
  visible = true,
  onClose = () => {},
}: {
  message: string;
  visible?: boolean;
  onClose?: () => void;
}) => {
  const [hidden, setHidden] = useState(!visible);
  const hideFlash = () => {
    setHidden(true);
    onClose();
  };
  return (
    <p
      className={`p-3 rounded-full bg-lime-300 dark:bg-lime-800 alert-success text-center alert-dismissible flex drop-shadow ${
        hidden && "hidden"
      }`}
      role="alert"
    >
      <BellAlertIcon className="h-6 w-6 mr-3" />
      <span className="mr-2">{message}</span>
      <XCircleIcon className="h-6 w-6 cursor-pointer" onClick={hideFlash} />
    </p>
  );
};

export default FlashNotice;
